import { HorizontalAlignment } from './types';
import { makeStyles } from '@material-ui/core';
import { ReactComponent as HorizontalAlignCenterIcon } from 'assets/icons/horizontal-align-center.svg';
import { ReactComponent as HorizontalAlignLeftIcon } from 'assets/icons/horizontal-align-left.svg';
import { ReactComponent as HorizontalAlignRightIcon } from 'assets/icons/horizontal-align-right.svg';
import React, { useCallback } from 'react';

interface StyleParams {
    isSelected: boolean;
}

const useStyles = makeStyles({
    container: {
        cursor: 'pointer',
        height: 24,
        width: 24,
    },
    icon: {
        fill: (params: StyleParams) => (params.isSelected ? '#243143' : 'rgba(36, 49, 67, 0.6)'),
        transition: '0.1s ease fill',
    },
});

const icons = {
    [HorizontalAlignment.LEFT]: HorizontalAlignLeftIcon,
    [HorizontalAlignment.CENTER]: HorizontalAlignCenterIcon,
    [HorizontalAlignment.RIGHT]: HorizontalAlignRightIcon,
};

export interface HorizontalAlignmentButtonProps {
    alignment: HorizontalAlignment;
    isSelected: boolean;
    onSelect: (value: HorizontalAlignment) => void;
}

export const HorizontalAlignmentButton = (props: HorizontalAlignmentButtonProps) => {
    const { alignment, isSelected, onSelect } = props;

    const Icon = icons[alignment];

    const handleClick = useCallback(() => onSelect(alignment), [alignment, onSelect]);

    const classes = useStyles({ isSelected });

    return (
        <div className={classes.container} onClick={handleClick}>
            <Icon className={classes.icon} />
        </div>
    );
};
